(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row2"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  // 全局事件委托（解决动态渲染与点击失效）
  if (!window.__accordion_toggle_event_bound__) {
    window.__accordion_toggle_event_bound__ = true;

    document.addEventListener('click', function(e) {
      // 处理 Read more... / Read less 点击切换
      const toggleBtn = e.target.closest('[data-description-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = toggleBtn.closest('[data-description-wrapper]');
        if (!wrapper) return;

        const isExpanded = wrapper.getAttribute('data-expanded') === 'true';
        if (isExpanded) {
          wrapper.setAttribute('data-expanded', 'false');
          toggleBtn.textContent = 'Read more...';
        } else {
          wrapper.setAttribute('data-expanded', 'true');
          toggleBtn.textContent = 'Read less';
        }
        return;
      }

      // 处理 Jump ID 跳转点击
      const summary = e.target.closest('details[data-jumpId] > summary');
      if (summary) {
        const details = summary.closest('details');
        if (!details) return;
        const targetId = details.getAttribute('data-jumpId');
        if (!targetId) return;

        e.preventDefault();
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          console.warn('[Accordion Jump] 未找到 ID 为 "' + targetId + '" 的元素');
        }
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sample-accordion-row"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.__sampleAccordionOverviewToggleBound__) return;

    window.__sampleAccordionOverviewToggleBound__ = true;

    document.addEventListener('click', function (event) {
      const toggleButton = event.target.closest('[data-sample-description-toggle]');
      if (!toggleButton) return;

      event.preventDefault();
      event.stopPropagation();

      const wrapper = toggleButton.closest('[data-sample-description-wrapper]');
      if (!wrapper) return;

      const isExpanded = wrapper.getAttribute('data-expanded') === 'true';
      wrapper.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
      toggleButton.textContent = isExpanded ? 'Read more...' : 'Read less';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nordan-product-status-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const productSelectEvent = 'shopify:product:select';

    class NordanProductStatusBadges extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section, dialog');
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.section?.addEventListener(productSelectEvent, this.handleProductSelect);
        this.updateAvailability(this.dataset.available === 'true');
      }

      disconnectedCallback() {
        this.section?.removeEventListener(productSelectEvent, this.handleProductSelect);
      }

      handleProductSelect(event) {
        if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

        event.promise
          .then(({ detail }) => {
            if (!detail) return;

            const productId = String(detail.productId || '');
            if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

            this.updateAvailability(detail.resource?.available === true);
          })
          .catch((error) => {
            if (error?.name !== 'AbortError') {
              console.warn('[nordan-product-status-badges] Variant update failed.', error);
            }
          });
      }

      updateAvailability(available) {
        this.dataset.available = String(available);

        const label = this.querySelector('[data-nordan-inventory-label]');
        if (label) {
          label.textContent = available ? label.dataset.inStockText || 'In Stock' : label.dataset.outOfStockText || 'Out of Stock';
        }

        const inStockIcon = this.querySelector('[data-nordan-in-stock-icon]');
        const outOfStockIcon = this.querySelector('[data-nordan-out-of-stock-icon]');
        if (inStockIcon) inStockIcon.hidden = !available;
        if (outOfStockIcon) outOfStockIcon.hidden = available;
      }
    }

    if (!customElements.get('nordan-product-status-badges')) {
      customElements.define('nordan-product-status-badges', NordanProductStatusBadges);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nordan2-product-intro"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__nordan2ProductIntroBound) return;
    window.__nordan2ProductIntroBound = true;

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-nordan2-product-intro-toggle]');

      if (toggle) {
        event.preventDefault();

        const item = toggle.closest('[data-nordan2-product-intro-content]');
        if (!item) return;

        const willExpand = item.dataset.expanded !== 'true';
        item.dataset.expanded = String(willExpand);
        toggle.setAttribute('aria-expanded', String(willExpand));
        toggle.textContent = willExpand ? toggle.dataset.readLess : toggle.dataset.readMore;
        return;
      }

      const anchor = event.target.closest('[data-nordan2-product-intro-anchor]');
      if (!anchor) return;

      const targetId = anchor.dataset.targetId;
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nordan2-product-status-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const productSelectEvent = 'shopify:product:select';

    class Nordan2ProductStatusBadges extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section, dialog');
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.section?.addEventListener(productSelectEvent, this.handleProductSelect);
        this.updateAvailability(this.dataset.available === 'true');
      }

      disconnectedCallback() {
        this.section?.removeEventListener(productSelectEvent, this.handleProductSelect);
      }

      handleProductSelect(event) {
        if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

        event.promise
          .then(({ detail }) => {
            if (!detail) return;

            const productId = String(detail.productId || '');
            if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

            this.updateAvailability(detail.resource?.available === true);
          })
          .catch((error) => {
            if (error?.name !== 'AbortError') {
              console.warn('[nordan2-product-status-badges] Variant update failed.', error);
            }
          });
      }

      updateAvailability(available) {
        this.dataset.available = String(available);

        const label = this.querySelector('[data-nordan-inventory-label]');
        if (label) {
          label.textContent = available ? label.dataset.inStockText || 'In Stock' : label.dataset.outOfStockText || 'Out of Stock';
        }

        const inStockIcon = this.querySelector('[data-nordan-in-stock-icon]');
        const outOfStockIcon = this.querySelector('[data-nordan-out-of-stock-icon]');
        if (inStockIcon) inStockIcon.hidden = !available;
        if (outOfStockIcon) outOfStockIcon.hidden = available;
      }
    }

    if (!customElements.get('nordan2-product-status-badges')) {
      customElements.define('nordan2-product-status-badges', Nordan2ProductStatusBadges);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
